import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Cirkel',
    polygon: 'Polygon',
    zip: 'Postnummer',
  },
  fields: {
    name: {
      label: 'Navn',
    },
    color: {
      label: 'Farve',
    },
    min_threshold: {
      label: 'Minimumsbeløb for bestilling',
    },
    max_threshold: {
      label: 'Maksimumsbeløb for bestilling',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Leveringsgebyr',
      },
      [DeliveryMode.External]: {
        label: 'Gebyr betales af restauranten',
      },
    },
    zip_codes: {
      label: 'Postnumre (ét pr. linje)',
    },
  },
  labels: {
    hidden: '(skjult)',
  },
  buttons: {
    save: 'Gem',
    cancel_changes: 'Annuller ændringer',
    add_max_order_amount: 'Tilføj maks. bestillingsbeløb',
  },
  modals: {
    delete_confirmation: {
      title: 'Er du sikker på, at du vil slette {{name}}?',
    },
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne for {{name}} kunne ikke gemmes',
    delivery_zone_got_updated: 'Ændringerne for {{name}} er gemt',
    failed_to_delete_delivery_zone: '{{name}} kunne ikke slettes',
    delivery_zone_got_deleted: '{{name}} er slettet',
  },
};
